import Phaser from "phaser";
import { ENEMY_FONT_SIZE, GAME_WIDTH } from "../config";

/** 敵文章エンティティ：文字列をText群として横並びに配置し、全体を下に移動 */
export class EnemySentence {
  private scene: Phaser.Scene;
  private container: Phaser.GameObjects.Container;
  private charTexts: Phaser.GameObjects.Text[];
  private charVisible: boolean[];
  private fallSpeed: number;
  private text: string;

  constructor(scene: Phaser.Scene, text: string, fallSpeed: number) {
    this.scene = scene;
    this.text = text;
    this.fallSpeed = fallSpeed;
    this.charTexts = [];
    this.charVisible = [];

    this.container = scene.add.container(0, 0);

    const charWidth = ENEMY_FONT_SIZE * 1.2;
    const totalWidth = text.length * charWidth;
    const startX = (GAME_WIDTH - totalWidth) / 2;

    for (let i = 0; i < text.length; i++) {
      const charText = scene.add.text(startX + i * charWidth, 0, text[i], {
        fontSize: `${ENEMY_FONT_SIZE}px`,
        fontFamily: "'Hiragino Kaku Gothic Pro', 'Meiryo', sans-serif",
        color: "#ffffff",
        align: "center",
        padding: { x: 4, y: 4 },
      });
      charText.setOrigin(0.5, 0.5);
      charText.setInteractive(
        new Phaser.Geom.Rectangle(
          -charWidth / 2,
          -ENEMY_FONT_SIZE / 2,
          charWidth,
          ENEMY_FONT_SIZE * 1.5
        ),
        Phaser.Geom.Rectangle.Contains
      );

      this.container.add(charText);
      this.charTexts.push(charText);
      this.charVisible.push(true);
    }

    // 初期位置: 画面上部外
    this.container.setPosition(0, -ENEMY_FONT_SIZE);
  }

  /** 毎フレーム更新：下に移動 */
  update(dt: number): void {
    this.container.y += this.fallSpeed * dt;
  }

  /** 座標から文字インデックスを取得（null: 該当なし） */
  pickCharAt(worldX: number, worldY: number): number | null {
    for (let i = 0; i < this.charTexts.length; i++) {
      if (!this.charVisible[i]) continue;

      const charText = this.charTexts[i];
      // コンテナオフセット含むワールド座標
      const cx = this.container.x + charText.x;
      const cy = this.container.y + charText.y;
      const charWidth = ENEMY_FONT_SIZE * 1.2;
      const charHeight = ENEMY_FONT_SIZE * 1.5;

      if (
        worldX >= cx - charWidth / 2 &&
        worldX <= cx + charWidth / 2 &&
        worldY >= cy - charHeight / 2 &&
        worldY <= cy + charHeight / 2
      ) {
        return i;
      }
    }
    return null;
  }

  /** ヒット処理: 文字を非表示にし、ワールド座標を返す */
  hit(index: number): { x: number; y: number; char: string } {
    const charText = this.charTexts[index];
    this.charVisible[index] = false;
    charText.setVisible(false);

    return {
      x: this.container.x + charText.x,
      y: this.container.y + charText.y,
      char: this.text[index],
    };
  }

  /** 敵が画面下端に到達したか */
  isReachedBottom(gameHeight: number): boolean {
    return this.container.y >= gameHeight;
  }

  /** 落下速度を更新 */
  setFallSpeed(speed: number): void {
    this.fallSpeed = speed;
  }

  /** 破棄 */
  destroy(): void {
    this.container.destroy(true);
  }
}
